const INFO = {
	main: {
		title: "Sharjeel Faiq | Senior Full-Stack Developer",
		name: "Sharjeel Faiq",
		role: "Senior Full-Stack Developer",
		email: "sharjeelfaiq816@gmail.com",
		emailHref: "mailto:sharjeelfaiq816@gmail.com",
		phone: "",
		location: "Islamabad, Pakistan",
		website: "https://sharjeelfaiq.vercel.app",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/sharjeelfaiq",
		linkedin: "https://pk.linkedin.com/in/sharjeelfaiq",
		website: "https://sharjeelfaiq.vercel.app",
		stackoverflow: "https://stackoverflow.com/users/13772273/sharjeel-faiq",
		npm: "https://www.npmjs.com/~mrmalik610",
		medium: "https://medium.com/@sharjeelfaiq",
		linktree: "https://linktr.ee/sharjeelfaiq",
		whatsapp: "",
	},

	contact: {
		title: "Let us talk about your product, platform, or automation workflow.",
		description:
			"Send a short note if you need help building or improving a full-stack product. I am a strong fit for React, Node.js, database, DevOps, integration, and AI automation work where the goal is a dependable business outcome.",
		links: [
			{
				label: "Email",
				value: "sharjeelfaiq816@gmail.com",
				href: "mailto:sharjeelfaiq816@gmail.com",
			},
			{
				label: "LinkedIn",
				value: "linkedin.com/in/sharjeelfaiq",
				href: "https://pk.linkedin.com/in/sharjeelfaiq",
			},
			{
				label: "GitHub",
				value: "github.com/sharjeelfaiq",
				href: "https://github.com/sharjeelfaiq",
			},
			{
				label: "NPM",
				value: "npmjs.com/~mrmalik610",
				href: "https://www.npmjs.com/~mrmalik610",
			},
			{
				label: "Medium",
				value: "medium.com/@sharjeelfaiq",
				href: "https://medium.com/@sharjeelfaiq",
			},
			{
				label: "Linktree",
				value: "linktr.ee/sharjeelfaiq",
				href: "https://linktr.ee/sharjeelfaiq",
			},
		],
	},

	homepage: {
		title: "Full stack developer in Pakistan building business-critical web platforms.",
		description:
			"I help SaaS teams, founders, and product owners ship reliable React, Node.js, database, DevOps, and AI integration solutions from Islamabad, Pakistan.",
		primaryCTA: {
			label: "Contact Me",
			href: "/contact",
		},
		secondaryCTA: {
			label: "View Projects",
			href: "#projects",
		},
		trustPoints: [
			"5+ years in MERN and PERN stack development.",
			"Supported systems handling 500K+ daily transactions.",
			"Improved application performance by 40-50%.",
		],
	},

	about: {
		title: "I am Sharjeel Faiq, a senior full-stack developer focused on practical business outcomes.",
		description:
			"My work spans frontend systems, backend APIs, databases, DevOps, integrations, and AI automation. I focus on turning ambiguous product needs into stable software: scalable dashboards, transaction-heavy systems, integrations, and workflows that teams can operate without friction.",
		highlights: [
			"Full-stack delivery across React, Node.js, Express, MongoDB, PostgreSQL, and cloud deployment workflows.",
			"Strong fit for SaaS dashboards, internal tools, automation workflows, and production system improvements.",
			"Comfortable owning product requirements, architecture decisions, implementation, and operational polish.",
		],
	},

	articles: {
		title: "Articles are currently offline.",
		description:
			"This portfolio is focused on project work, technical capability, and direct contact.",
	},

	services: [
		{
			title: "Full-Stack Web Development",
			description:
				"Plan, build, and ship production web applications with React, Node.js, Express, and reliable database foundations.",
		},
		{
			title: "SaaS Dashboards and Internal Tools",
			description:
				"Turn complex operational data into clear interfaces, workflows, reports, and admin systems teams can use every day.",
		},
		{
			title: "API and Integration Engineering",
			description:
				"Design maintainable REST APIs, authentication flows, third-party integrations, and backend services.",
		},
		{
			title: "Performance and DevOps Support",
			description:
				"Improve slow user flows, tune backend response paths, and support cloud deployments, CI/CD, and release readiness.",
		},
		{
			title: "AI Automation",
			description:
				"Connect product data, business processes, and AI-assisted workflows to reduce repetitive manual work.",
		},
		{
			title: "Freelance Development",
			description:
				"Support focused freelance full-stack development projects where teams need dependable React, Node.js, SaaS, or automation delivery.",
		},
	],

	skills: [
		{
			group: "Frontend",
			items: ["React", "Next.js", "JavaScript", "TypeScript", "Responsive UI", "Bootstrap"],
		},
		{
			group: "Backend",
			items: ["Node.js", "Express", "REST APIs", "Authentication", "Integrations", "JWT"],
		},
		{
			group: "Databases",
			items: ["MongoDB", "PostgreSQL", "MySQL", "Schema Design", "Data Modeling"],
		},
		{
			group: "DevOps",
			items: ["Cloud Deployments", "CI/CD", "Performance Tuning", "Monitoring", "Vercel"],
		},
		{
			group: "AI and Automation",
			items: ["OpenAI", "Workflow Automation", "AI Integrations", "Internal Tools"],
		},
	],

	capabilities: [
		{
			group: "Frontend",
			items: ["React", "Next.js", "JavaScript", "TypeScript", "Responsive UI"],
		},
		{
			group: "Backend",
			items: ["Node.js", "Express", "REST APIs", "Authentication", "Integrations"],
		},
		{
			group: "Databases",
			items: ["PostgreSQL", "MongoDB", "MySQL", "Schema Design"],
		},
		{
			group: "DevOps",
			items: ["Cloud Deployments", "CI/CD", "Performance Tuning", "Monitoring"],
		},
		{
			group: "AI Automation",
			items: ["Workflow Automation", "AI Integrations", "Internal Tools"],
		},
	],

	experience: [
		{
			company: "Qultech Pvt. Ltd",
			role: "Senior Full-Stack Developer",
			period: "Current",
			location: "Islamabad, Pakistan",
			description:
				"Build and improve full-stack web platforms, dashboards, APIs, and operational workflows for business-critical software.",
		},
		{
			company: "Freelance and Product Work",
			role: "Full-Stack Developer",
			period: "5+ years",
			location: "Remote",
			description:
				"Delivered MERN and PERN stack applications, automation tools, performance improvements, and reusable backend foundations.",
		},
	],

	proofPoints: [
		"Supported systems handling 500K+ daily transactions.",
		"Improved application performance by 40-50%.",
		"Built full-stack products across frontend, backend, databases, DevOps, and AI automation.",
	],

	projects: [
		{
			title: "Vocora",
			description:
				"A MERN-based AI voiceover platform that turns text into lifelike speech for creators, educators, and businesses.",
			outcome: "Ships a focused AI voice workflow with realistic voices, fast rendering, and a simple web interface.",
			stack: ["MongoDB", "Express", "React", "Node.js", "OpenAI"],
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			live: "https://vocora.cloud",
		},
		{
			title: "Textbotonline",
			description:
				"A browser-based toolkit for editing, formatting, analyzing, generating, converting, and encoding text without signup.",
			outcome: "Provides fast, privacy-friendly client-side utilities for writers, developers, and analysts.",
			stack: ["React", "JavaScript", "Bootstrap", "Client-Side Tools"],
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			live: "https://textbotonline.vercel.app",
		},
		{
			title: "MERN Backend Starter",
			description:
				"A production-ready backend foundation with JWT authentication, security practices, email workflows, file upload support, and API documentation.",
			outcome: "Helps freelancers, agencies, and startups save setup time before building custom products.",
			stack: ["Node.js", "Express", "MongoDB", "JWT", "Swagger"],
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			github: "https://github.com/sharjeelfaiq/mern-backend-starter-javascript",
		},
		{
			title: "High-Volume Transaction Platform",
			description:
				"Improved a business-critical platform for high-throughput transaction workflows with stable APIs and performance-focused architecture.",
			outcome: "Supported 500K+ daily transactions while improving reliability and maintainability.",
			stack: ["React", "Node.js", "REST APIs", "PostgreSQL", "Cloud"],
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},
		{
			title: "Performance-Focused Web Application",
			description:
				"Refined a production web application by reducing bottlenecks across rendering, data access, and backend response paths.",
			outcome: "Delivered a 40-50% performance improvement for core user workflows.",
			stack: ["React", "JavaScript", "Node.js", "Performance Tuning"],
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},
		{
			title: "AI Automation and Internal Tools",
			description:
				"Created automation workflows and internal tools that connect product data, operational processes, and AI-assisted actions.",
			outcome: "Reduced repetitive manual work and gave teams clearer visibility into daily operations.",
			stack: ["AI Integrations", "Node.js", "APIs", "Databases", "Automation"],
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
		},
	],

	openSource: [
		{
			title: "MERN Backend Starter JavaScript",
			description:
				"Reusable Express and MongoDB backend starter with authentication, security defaults, file uploads, and documentation.",
			link: "https://github.com/sharjeelfaiq/mern-backend-starter-javascript",
			tags: ["Node.js", "Express", "MongoDB", "JWT"],
		},
		{
			title: "NPM Packages",
			description:
				"JavaScript tooling and package work published under Sharjeel Faiq's NPM profile.",
			link: "https://www.npmjs.com/~mrmalik610",
			tags: ["JavaScript", "NPM", "Developer Tools"],
		},
	],

	testimonial: {
		title: "Client and peer feedback",
		description:
			"Recommendations are available on LinkedIn, including feedback on MERN delivery, clean code, communication, frontend proficiency, and collaboration.",
		video: "",
		link: "https://pk.linkedin.com/in/sharjeelfaiq",
		linkLabel: "View LinkedIn recommendations",
	},
};

export default INFO;
